module.exports = __webpack_public_path__ + "static/img/baas_main_1.5abf8a0.webp";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/baas_main_1.webp
// module id = uUp+
// module chunks = 0